import Component from "gia/Component";
import Channels from "../base/channels";

export default class Module extends Component {
  constructor(element) {
    super(element);
    this.ref = {};
  }

  mount() {
    this.DOM = {};
    this.DOM.view = this.element;

    Channels.emit("cart::open");
  }

  unmount() {}
}
